export default "__VITE_ASSET__CM$D0R7r__"